var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCaseDesigner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "340px",
    height: "190px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 128.04 71.55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .str0 {stroke:#C4337C;stroke-width:0.75;stroke-miterlimit:22.9256;stroke-dasharray:0.750000 0.750000}\n    .fil27 {fill:none}\n    .fil9 {fill:#005F87}\n    .fil6 {fill:#00AAAD}\n    .fil17 {fill:#333333}\n    .fil3 {fill:#3A4553}\n    .fil13 {fill:#3AA9AE}\n    .fil15 {fill:#424C5C}\n    .fil11 {fill:#4A535B}\n    .fil23 {fill:#4D4D4D}\n    .fil22 {fill:#B3B3B3}\n    .fil18 {fill:#BCC0C4}\n    .fil24 {fill:#C4337C}\n    .fil2 {fill:gainsboro}\n    .fil7 {fill:#E9E9E9}\n    .fil16 {fill:#EB7809}\n    .fil1 {fill:#EB7809}\n    .fil19 {fill:#EBF0F5}\n    .fil10 {fill:#EDEDEA}\n    .fil20 {fill:#F2F2F2}\n    .fil26 {fill:#F3F3F3}\n    .fil5 {fill:#F5F7F7}\n    .fil8 {fill:#FAFAFA}\n    .fil14 {fill:#FFB800}\n    .fil0 {fill:#FFD464}\n    .fil21 {fill:white}\n    .fil12 {fill:#FFB800;fill-rule:nonzero}\n    .fil25 {fill:white;fill-opacity:0.101961}\n    .fil4 {fill:#4E5864;fill-opacity:0.200000}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 128.04,
    height: 71.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 36.99,
    y: 35.28,
    width: 2.02,
    height: 15.67,
    rx: 1.01,
    ry: 4.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 36.99,
    y: 46.53,
    width: 2.02,
    height: 15.67,
    rx: 1.01,
    ry: 4.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "59.38,54.78 76.56,59.97 75.13,54.68 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M47.05 20.83l40.15 0c1.81,0 3.28,1.45 3.28,3.21l0 24.91 -46.71 0 0 -24.91c0,-1.76 1.47,-3.21 3.28,-3.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M47.05 20.83l40.15 0c1.81,0 3.28,1.45 3.28,3.21l0 24.91 -46.71 -24.91c0,-1.76 1.47,-3.21 3.28,-3.21z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5",
    x: 60.16,
    y: 9.42,
    width: 25.81,
    height: 27.73,
    rx: 1.38,
    ry: 1.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M61.54 9.05l23.06 0c0.75,0 1.37,0.62 1.37,1.38l0 2.4 -25.81 0 0 -2.4c0,-0.76 0.62,-1.38 1.38,-1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M90.48 48.95l0 3.98c0,1.18 -0.9,2.15 -2.01,2.15l-42.69 0c-1.11,0 -2.01,-0.97 -2.01,-2.15l0 -3.98 46.71 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil8",
    points: "94.51,14.67 95.46,14.64 96.42,17.34 93.48,17.43 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M33.88 62.2c0.34,-3.15 0.13,-7.84 0.14,-11.23 0,-2.62 1.27,-10.35 -0.14,-10.61l-1.45 0c-1.41,0.26 -0.15,7.99 -0.15,10.61 0.01,3.39 -0.19,8.08 0.14,11.23l1.46 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M32.31 40.36l1.57 0c0.12,-3.34 -0.09,-2.92 -1.5,-4.96l-0.07 4.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil11",
    points: "94.51,14.67 95.51,14.64 94.99,13.65 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil12",
    points: "74.88,21.84 76.45,21.84 76.45,26.44 74.88,26.44 74.88,26.85 76.83,26.85 76.83,21.43 76.64,21.43 74.88,21.43 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil13",
    cx: 86.77,
    cy: 52.13,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 83.8,
    cy: 52.13,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil15",
    cx: 80.98,
    cy: 52.13,
    r: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil16",
    x: 93.51,
    y: 17.34,
    width: 2.99,
    height: 39.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M96.5 58.74l0 3.78c0,0.2 -0.17,0.36 -0.37,0.36l-2.25 0c-0.2,0 -0.37,-0.16 -0.37,-0.36l0 -3.78 2.99 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M95 62.88l-1.12 0c-0.2,0 -0.37,-0.16 -0.37,-0.36l0 -3.78 1.49 0 0 4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M95 62.88l-1.12 0c-0.2,0 -0.37,-0.16 -0.37,-0.36l0 -3.78 1.49 0 0 4.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil18",
    x: 93.51,
    y: 56.35,
    width: 2.99,
    height: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil19",
    cx: 64.88,
    cy: 10.91,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil19",
    cx: 62.62,
    cy: 10.91,
    r: 0.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil20",
    points: "58.13,60 59.38,54.78 76.56,59.97 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil21",
    x: 93.51,
    y: 58,
    width: 2.99,
    height: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil21",
    d: "M43.77 26.53l-8.4 0c-1.05,-0.14 -1.99,-0.45 -2.7,-1.08 -2.91,-2.56 -5.3,-2.6 -7.66,0.31l3.96 0.15 1.13 2.11 -1.13 2.12 -3.96 0.14c2.36,2.92 4.75,2.87 7.66,0.31 0.64,-0.57 1.47,-0.88 2.41,-1.03l8.69 0 0 -3.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil19",
    x: 36.99,
    y: 46.5,
    width: 2.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil21",
    points: "36.99,49.95 39.02,46.5 39.02,50.04 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil22",
    x: 36.14,
    y: 38.09,
    width: 0.6,
    height: 6.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil23",
    points: "36.14,38.09 36.99,36.95 37.1,39.05 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil13",
    x: 69.9,
    y: 20.15,
    width: 4.98,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil13",
    x: 69.9,
    y: 25.17,
    width: 4.98,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil13",
    x: 69.9,
    y: 30.08,
    width: 4.98,
    height: 2.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil12",
    points: "69.9,16.86 68.18,16.86 68.18,21.45 69.9,21.45 69.9,21.85 67.76,21.85 67.76,16.46 67.97,16.46 69.9,16.46 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil12",
    points: "69.9,26.63 68.34,26.63 68.34,31.24 69.9,31.24 69.9,31.65 67.96,31.65 67.96,26.22 68.15,26.22 69.9,26.22 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil19",
    cx: 67.25,
    cy: 10.91,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil24",
    cx: 72.2,
    cy: 16.15,
    r: 2.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil25",
    points: "93.51,17.35 95,17.35 95,58.74 93.51,58.74 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil25",
    d: "M95 58.74l0 4.14 -1.12 0c-0.2,0 -0.37,-0.16 -0.37,-0.36l0 -3.78 1.49 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil26",
    x: 34.83,
    y: 27.41,
    width: 8.94,
    height: 1.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "fil27 str0",
    points: "74.5,16.66 78.99,16.66 78.99,31.45 74.88,31.45 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 53.85,
    y: 59.6,
    width: 27.1,
    height: 3.08,
    rx: 1.44,
    ry: 1.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseDesigner);
export default __webpack_public_path__ + "static/media/use-case-designer.4ab1af16871332c0fd9fc82bfac3a969.svg";
export { ForwardRef as ReactComponent };